"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7l-5-5H6zm2 14h8v2H8v-2zm8-4H8v2h8v-2z" }), "File");
//# sourceMappingURL=File.js.map